var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.value === null ? '' : _vm.formatFieldOutputValue(_vm.field, _vm.value))+" "+_vm._s(_vm.options.suffix ? _vm.options.suffix : '')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }